import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { getPublicConfigUrl } from '@utils/publicConfigUrl';
import { setSocketBaseUrl } from '@utils/socket';

const PublicConfigContext = createContext(null);

const empty = {
  mapboxToken: '',
  googleMapsApiKey: '',
  googleClientId: '',
  socketUrl: '',
  siteOrigin: '',
  ready: false,
};

export const PublicConfigProvider = ({ children }) => {
  const [state, setState] = useState(empty);

  useEffect(() => {
    let cancelled = false;
    fetch(getPublicConfigUrl())
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error(String(res.status)))))
      .then((data) => {
        if (cancelled) return;
        const next = {
          mapboxToken: data.mapboxToken || '',
          googleMapsApiKey: data.googleMapsApiKey || '',
          googleClientId: (data.googleClientId || '').trim(),
          socketUrl: data.socketUrl || '',
          siteOrigin: (data.siteOrigin || '').trim().replace(/\/$/, ''),
          ready: true,
        };
        setState(next);
        const socketTarget =
          next.socketUrl ||
          (typeof process !== 'undefined' && process.env.SOCKET_URL ? process.env.SOCKET_URL : '') ||
          '';
        setSocketBaseUrl(socketTarget);
      })
      .catch(() => {
        if (cancelled) return;
        setState({ ...empty, ready: true });
        const fallback =
          (typeof process !== 'undefined' ? process.env.SOCKET_URL : '') || '';
        setSocketBaseUrl(fallback);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(() => state, [state]);

  return (
    <PublicConfigContext.Provider value={value}>{children}</PublicConfigContext.Provider>
  );
};

export const usePublicConfig = () => {
  const ctx = useContext(PublicConfigContext);
  if (!ctx) {
    throw new Error('usePublicConfig must be used within PublicConfigProvider');
  }
  return ctx;
};
